import { render, staticRenderFns } from "./device-cell.vue?vue&type=template&id=0b5c04de&scoped=true"
import script from "./device-cell.vue?vue&type=script&lang=js"
export * from "./device-cell.vue?vue&type=script&lang=js"
import style0 from "./device-cell.vue?vue&type=style&index=0&id=0b5c04de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c04de",
  null
  
)

export default component.exports